import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { t } from "@i18n";

function RolesModalContent({ value, dataSource, onChange }: any) {
  return (
    <div className="flex flex-col gap-5 pb-2">
      <div className="flex items-center gap-5 p-5 pb-0">
        <div className="text-lg font-semibold text-[var(--primary-text)]" data-testid="selectSingleRoleToAll">
          {t("Select a single role for selected users")}
        </div>
      </div>

      <div className="flex h-20 items-center gap-10 border-px border-[var(--button-light)] ps-10">
        <div className="text-lg font-semibold text-[var(--primary-text)]" data-testid="role">
          {t("Role")}
        </div>
        <AutoComplete
          options={dataSource || []}
          valueField="id"
          getOptionLabel={(option: any) => option?.frontendName || ""}
          value={dataSource?.find((opt: any) => opt.id === value) || null}
          onChange={(_event: any, newValue: any) => onChange({ value: newValue?.id, itemData: newValue })}
          sx={{ width: "8.75rem" }}
          renderInput={(params: any) => <TextFieldComponent {...params} placeholder={t("Select Role")} />}
          data-testid="selectRoleInBulkUpdate"
        />
      </div>
    </div>
  );
}

export default RolesModalContent;
